// extracted by mini-css-extract-plugin
export default {"meeting":"MeetingView_meeting__dJ9Gm","box":"MeetingView_box__Et2AI","view":"MeetingView_view__DAHGk","flex":"MeetingView_flex__zbpbr"};